export function logoutNotificationToExt () {
    const CE_LOGOUT = "CE_LOGOUT";
    window.postMessage({
        type: CE_LOGOUT,
    }, window.location.origin);
};
